import React from 'react';
import {View, ViewStyle} from 'react-native';

import {styles} from './FlexView.style';

interface FlexViewProps {
  children: React.ReactNode;
  direction: 'horizontal' | 'vertical';
  align: 'start' | 'center' | 'end' | 'stretch';
  crossAlign: 'start' | 'center' | 'end';
  expand: boolean;
}

export const FlexView: React.FC<FlexViewProps> = ({
  children = null,
  direction = 'vertical',
  align = 'start',
  crossAlign = 'start',
  expand = true,
}) => {
  const style: ViewStyle[] = [styles.base];

  if (direction === 'horizontal') {
    style.push(styles.directionHorizontal);
  } else {
    style.push(styles.directionVertical);
  }

  if (align === 'start') {
    style.push(styles.alignStart);
  } else if (align === 'center') {
    style.push(styles.alignCenter);
  } else if (align === 'end') {
    style.push(styles.alignEnd);
  } else {
    style.push(styles.alignStretch);
  }

  if (crossAlign === 'start') {
    style.push(styles.crossAlignStart);
  } else if (crossAlign === 'center') {
    style.push(styles.crossAlignCenter);
  } else {
    style.push(styles.crossAlignEnd);
  }

  if (expand) {
    style.push(styles.expand);
  }

  return <View style={style}>{children}</View>;
};

export default FlexView;
